import { render, staticRenderFns } from "./HeaderUserMenu.vue?vue&type=template&id=7e35970c&"
import script from "./HeaderUserMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderUserMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderUserMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports